export default "__VITE_ASSET__C_DzV6AC__"